import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import MainContext from '../common/MainContext';
import { canAccessPage, getPageKeyFromPath } from '../common/permissions';
import { auth } from "../firebase";

const ProtectedRoute = ({ component, permissionLevel = null, page = null }) => {

    const context = useContext(MainContext)
    const location = useLocation()

    if (!auth.currentUser) {
        return <Navigate to="/login" replace />
    }

    if (!context.user) {
        return null
    }

    if (context.user.force_change_password && location.pathname !== '/changePassword') {
        return <Navigate to="/changePassword" replace />
    }

    const pageKey = page ?? getPageKeyFromPath(location.pathname)
    const hasPermission = canAccessPage(context.user, pageKey, 'view', permissionLevel)

    if (!hasPermission) {
        return <Navigate to="/" replace />
    }

    return component
}

export default ProtectedRoute
